import { useId } from 'react';

import styles from './EditorHeader.module.css';

import { Label } from 'components';

interface EditorHeaderProps {
  label: string;
  info?: string;
  required?: boolean;
}

export const EditorHeader = ({ label, info = '', required = false }: EditorHeaderProps) => {
  const infoId = `info_${useId()}`;

  return (
    <div className={styles['editor-header__container']}>
      {label !== '' && (
        <div>
          <Label htmlFor={infoId} required={required}>
            {label}
          </Label>
        </div>
      )}
      {info !== '' && <div className={styles['editor-header__info']} dangerouslySetInnerHTML={{ __html: info }} />}
    </div>
  );
};
